import theme from "theme";
import { colors } from "theme/palette";

import Button from "components/Button";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IMemoESignatureDrawerWarningMessageContent {
  onClose: () => void;
  setDrawerStepToContactAssignmentOverview: () => void;
}

const MemoESignatureDrawerWarningMessageContent = ({
  onClose,
  setDrawerStepToContactAssignmentOverview,
}: IMemoESignatureDrawerWarningMessageContent) => (
  <Stack padding={theme.spacing(3, 4)} flex={1} gap={3}>
    <Stack
      padding={theme.spacing(3, 4)}
      borderRadius="8px"
      sx={{
        padding: theme.spacing(3, 4),
        backgroundColor: colors.gray10,
      }}
    >
      <Text variant="text1">Before you start, please check:</Text>
      <br />
      <Text variant="text2" fontWeight={500}>
        • if all required information has been filled out
      </Text>
      <Text variant="text2" fontWeight={500}>
        • if the contents of the document are correct
      </Text>
      <Text variant="text2" fontWeight={500}>
        • if there are sections that are not needed, they have been marked N/A
        (hidden)
      </Text>
      <Text variant="text2" fontWeight={500}>
        • if there are signatures that don’t need to be collected, they have
        been marked N/A
      </Text>
    </Stack>
    <Stack width="600px" marginLeft={4} flex={1}>
      <Text color={colors.gray80} variant="text2">
        If everything looks good & final, a PDF will be generated from your
        document editor. Once the PDF is created and the signature collection
        process starts, no further edits to the documents will be reflected in
        the e-sign document.
      </Text>
      <br />
      <Text color={colors.gray80} variant="text2">
        If you need to make changes to the document, you can exit from this
        e-sign setup process any time, make your edits, then restart the
        process. If the e-sign requests have already been sent out but not yet
        signed, the process can still be cancelled and restarted.
      </Text>
    </Stack>
    <Stack direction="row" alignSelf="flex-end">
      <Button onClick={onClose} variant="text">
        Cancel
      </Button>
      <Button onClick={setDrawerStepToContactAssignmentOverview}>
        Yes, proceed
      </Button>
    </Stack>
  </Stack>
);

export default MemoESignatureDrawerWarningMessageContent;
